export default __webpack_public_path__ + "static/media/bg-5.930a9475.jpg";